export default __webpack_public_path__ + "3a73d8aec5582a634b28c16f0eccaf9e.png";